import { render, staticRenderFns } from "./phrase.vue?vue&type=template&id=341b42d5&scoped=true&"
import script from "./phrase.vue?vue&type=script&lang=js&"
export * from "./phrase.vue?vue&type=script&lang=js&"
import style0 from "./phrase.vue?vue&type=style&index=0&id=341b42d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b42d5",
  null
  
)

export default component.exports